/**
 * Townties — Main Theme JavaScript
 * Vanilla ES2020+, no jQuery dependency
 */

'use strict';

/* ============================================================
   DOM helpers
   ============================================================ */
function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

/* ============================================================
   Sticky header
   ============================================================ */
(function() {
  var header = qs('#site-header');
  if (!header) return;
  var sentinel = qs('.announcement-bar') || qs('body');

  var observer = new IntersectionObserver(function(entries) {
    header.classList.toggle('is-sticky', !entries[0].isIntersecting);
  }, { threshold: 0 });

  observer.observe(sentinel);
})();

/* ============================================================
   Announcement bar dismiss
   ============================================================ */
(function() {
  var btn = qs('.js-announcement-close');
  var bar = qs('#announcement-bar');
  if (!btn || !bar) return;
  btn.addEventListener('click', function() {
    bar.style.display = 'none';
    try { sessionStorage.setItem('tt_announcement_closed', '1'); } catch(e) {}
  });
  try {
    if (sessionStorage.getItem('tt_announcement_closed') === '1') bar.style.display = 'none';
  } catch(e) {}
})();

/* ============================================================
   Mobile nav
   ============================================================ */
(function() {
  var navEl = qs('#mobile-nav');
  var overlay = qs('#mobile-nav-overlay');
  var toggleBtns = qsa('.js-nav-toggle');
  var closeBtn = qs('.js-nav-close');

  if (!navEl) return;

  function openNav() {
    navEl.classList.add('is-open');
    navEl.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    toggleBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
  }

  function closeNav() {
    navEl.classList.remove('is-open');
    navEl.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    toggleBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
  }

  toggleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      navEl.classList.contains('is-open') ? closeNav() : openNav();
    });
  });
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && navEl.classList.contains('is-open')) closeNav();
  });
})();

/* ============================================================
   Header search
   ============================================================ */
(function() {
  var searchBar = qs('#header-search');
  var input = qs('#search-input');
  var toggleBtns = qsa('.js-search-toggle');

  if (!searchBar) return;

  function openSearch() {
    searchBar.classList.add('is-open');
    searchBar.setAttribute('aria-hidden', 'false');
    toggleBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
    if (input) setTimeout(function() { input.focus(); }, 150);
  }

  function closeSearch() {
    searchBar.classList.remove('is-open');
    searchBar.setAttribute('aria-hidden', 'true');
    toggleBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    if (typeof Search !== 'undefined') Search.clearResults();
  }

  toggleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      searchBar.classList.contains('is-open') ? closeSearch() : openSearch();
    });
  });

  // Predictive search input
  if (input) {
    input.addEventListener('input', function() {
      if (typeof Search !== 'undefined') Search.debounce(input.value.trim());
    });
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!searchBar.contains(e.target) && !e.target.closest('.js-search-toggle')) {
      closeSearch();
    }
  });
})();

/* ============================================================
   Mission-request modal — open/close + source tracking + prefill
   ============================================================ */
(function() {
  var modal = qs('#request-mission-modal');
  if (!modal) return;
  var sourceInput = qs('#request-mission-source');
  var missionInput = qs('#request-mission-name');

  function open(opener) {
    if (sourceInput && opener) {
      sourceInput.value = opener.getAttribute('data-source') || '';
    }
    if (missionInput && opener) {
      var prefill = opener.getAttribute('data-mission-prefill');
      if (prefill && !missionInput.value) missionInput.value = prefill;
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (missionInput) setTimeout(function() { missionInput.focus(); }, 120);
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    var opener = e.target.closest('.js-request-open');
    if (opener) {
      e.preventDefault();
      open(opener);
      return;
    }
    var closer = e.target.closest('.js-request-close');
    if (closer && modal.contains(closer)) {
      e.preventDefault();
      close();
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
})();

/* ============================================================
   Collection card — direct Add to Cart button
   ============================================================ */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-card-atc');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-product-handle');

    function openCartDrawer() {
      var cartDrawer = qs('#cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('is-open');
        cartDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (typeof Cart !== 'undefined') {
          Cart.render();
          Cart.fetchUpsell();
        }
      }
    }

    if (variantId) {
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      if (typeof Cart !== 'undefined') {
        Cart.add(parseInt(variantId, 10), 1).then(function() {
          openCartDrawer();
          btn.disabled = false;
          btn.textContent = originalText;
        }).catch(function() {
          btn.disabled = false;
          btn.textContent = originalText;
        });
      }
    } else {
      // Multi-variant product — open quick view so user can choose.
      var card = btn.closest('.product-card');
      var qvBtn = card && card.querySelector('.js-quick-view');
      if (qvBtn) qvBtn.click();
    }
  });
})();

/* ============================================================
   Product page — sticky add-to-cart bar
   ============================================================ */
(function() {
  var stickyBar = qs('#sticky-atc');
  var mainAtc = qs('#add-to-cart');
  if (!stickyBar || !mainAtc || !('IntersectionObserver' in window)) return;

  function show() {
    stickyBar.classList.add('is-visible');
    stickyBar.setAttribute('aria-hidden', 'false');
  }
  function hide() {
    stickyBar.classList.remove('is-visible');
    stickyBar.setAttribute('aria-hidden', 'true');
  }

  new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        hide();
      } else if (entry.boundingClientRect.top < 0) {
        show();
      } else {
        hide();
      }
    });
  }, { threshold: 0 }).observe(mainAtc);

  // Mirror live price changes from variant selection into the sticky bar
  var mainPrice = qs('#product-price');
  var stickyPrice = qs('#sticky-atc-price');
  if (mainPrice && stickyPrice && 'MutationObserver' in window) {
    new MutationObserver(function() {
      stickyPrice.textContent = mainPrice.textContent;
    }).observe(mainPrice, { childList: true, characterData: true, subtree: true });
  }

  // Mirror availability (disabled state + label) from the main button
  var stickyBtn = qs('#sticky-atc-btn');
  if (mainAtc && stickyBtn && 'MutationObserver' in window) {
    new MutationObserver(function() {
      stickyBtn.disabled = mainAtc.disabled;
      stickyBtn.textContent = mainAtc.textContent.trim();
    }).observe(mainAtc, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
  }
})();

/* ============================================================
   Search page — predictive search on the banner input
   ============================================================ */
(function() {
  var bannerInput = qs('.search-banner__input');
  var bannerResults = qs('#search-banner-predictive');
  if (!bannerInput || !bannerResults) return;

  bannerInput.addEventListener('input', function() {
    if (typeof Search !== 'undefined') Search.debounce(bannerInput.value.trim(), 'search-banner-predictive');
  });

  // Close dropdown on outside click
  document.addEventListener('click', function(e) {
    if (!bannerResults.contains(e.target) && e.target !== bannerInput) {
      if (typeof Search !== 'undefined') Search.clearResults('search-banner-predictive');
    }
  });
})();

/* ============================================================
   Cart drawer
   ============================================================ */
(function() {
  var drawerEl = qs('#cart-drawer');
  if (!drawerEl) return;

  function openCart() {
    drawerEl.classList.add('is-open');
    drawerEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Render latest cart
    if (typeof Cart !== 'undefined') {
      Cart.render().catch(function(err) {
        console.error('Cart render failed:', err);
      });
      Cart.fetchUpsell();
    }
  }

  function closeCart() {
    drawerEl.classList.remove('is-open');
    drawerEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  qsa('.js-cart-toggle').forEach(function(btn) {
    btn.addEventListener('click', openCart);
  });
  qsa('.js-cart-close').forEach(function(btn) {
    btn.addEventListener('click', closeCart);
  });

  var overlay = qs('.js-cart-overlay');
  if (overlay) overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawerEl.classList.contains('is-open')) closeCart();
  });

  // Wire up pre-rendered remove buttons (for SSR items)
  drawerEl.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('.js-cart-remove');
    if (!removeBtn) return;
    var key = removeBtn.getAttribute('data-item-key');
    if (key && typeof Cart !== 'undefined') {
      Cart.change(key, 0).then(function() {
        Cart.render();
        Cart.fetchUpsell();
      });
    }
  });

  // Cart note
  var noteEl = qs('#cart-note');
  if (noteEl) {
    var noteTimer;
    noteEl.addEventListener('input', function() {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function() {
        if (typeof Cart !== 'undefined') Cart.updateNote(noteEl.value);
      }, 800);
    });
  }

  // If cart_type setting is 'drawer', intercept Add-to-Cart form submissions
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('#product-form');
    if (!form) return;

    // Only intercept if drawer is enabled
    var cartTypeEl = document.documentElement;
    // We always use the drawer approach from theme.liquid — intercept all ATC
    e.preventDefault();

    var variantId = parseInt(form.querySelector('[name="id"]').value);
    var qty = form.querySelector('[name="quantity"]') ? parseInt(form.querySelector('[name="quantity"]').value) : 1;

    // Collect line item properties
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function(input) {
      var key = input.name.replace('properties[', '').replace(']', '');
      if (input.value) props[key] = input.value;
    });

    var btn = form.querySelector('#add-to-cart');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    if (typeof Cart !== 'undefined') {
      Cart.add(variantId, qty, Object.keys(props).length ? props : undefined).then(function() {
        openCart();
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      }).catch(function(err) {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
        var msg = (err && err.description) || 'Could not add to cart.';
        alert(msg);
      });
    }
  });
})();

/* ============================================================
   Product page — variant selection
   ============================================================ */
(function() {
  var variantsEl = qs('#product-variants-json');
  if (!variantsEl) return;

  var variants;
  try { variants = JSON.parse(variantsEl.textContent); } catch(e) { return; }

  var selectedOptions = {};

  function getMatchingVariant() {
    return variants.find(function(v) {
      return v.options.every(function(opt, i) {
        return selectedOptions[i] === undefined || selectedOptions[i] === opt;
      });
    }) || variants.find(function(v) { return v.available; }) || variants[0];
  }

  function updateVariantUI(variant) {
    if (!variant) return;

    // Update variant ID hidden input
    var idInput = qs('#variant-id');
    if (idInput) idInput.value = variant.id;

    // Update price
    var priceEl = qs('#product-price');
    var compareEl = qs('#product-compare-price');
    if (priceEl && typeof formatMoney === 'function') {
      priceEl.textContent = formatMoney(variant.price);
    }
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.setAttribute('hidden', '');
      }
    }

    // Update ATC button
    var atcBtn = qs('#add-to-cart');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    // Update main image if variant has one
    if (variant.featured_image) {
      var mainImg = qs('#product-main-image');
      if (mainImg) {
        mainImg.src = variant.featured_image.src.replace(/(\.[^.]+)$/, '_1024x1024$1');
      }
    }

    // Update SKU
    var skuEl = qs('#variant-sku');
    if (skuEl) skuEl.textContent = variant.sku || '';

    // Stock notice
    var stockEl = qs('.stock-notice');
    if (stockEl) {
      if (!variant.available) {
        stockEl.textContent = 'Sold out';
        stockEl.className = 'stock-notice';
        stockEl.removeAttribute('hidden');
      } else if (variant.inventory_management === 'shopify' && variant.inventory_quantity <= 5 && variant.inventory_quantity > 0) {
        stockEl.textContent = 'Only ' + variant.inventory_quantity + ' left in stock';
        stockEl.className = 'stock-notice stock-notice--low';
        stockEl.removeAttribute('hidden');
      } else {
        stockEl.setAttribute('hidden', '');
      }
    }
  }

  // Initialize with first available variant
  var initialVariant = variants.find(function(v) { return v.available; }) || variants[0];
  if (initialVariant) {
    initialVariant.options.forEach(function(opt, i) { selectedOptions[i] = opt; });
    updateVariantUI(initialVariant);
  }

  // Color swatches
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.js-swatch');
    if (!swatch) return;
    var optionIndex = parseInt(swatch.getAttribute('data-option-index'));
    var value = swatch.getAttribute('data-value');
    selectedOptions[optionIndex] = value;

    // Update active state
    var container = swatch.closest('.swatches');
    if (container) {
      container.querySelectorAll('.js-swatch').forEach(function(s) {
        var isActive = s.getAttribute('data-value') === value;
        s.classList.toggle('is-active', isActive);
        s.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    // Update label
    var colorLabel = qs('#selected-color-label');
    if (colorLabel) colorLabel.textContent = value;

    updateVariantUI(getMatchingVariant());
  });

  // Width / other option selectors
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-option-selector');
    if (!btn) return;
    var optionIndex = parseInt(btn.getAttribute('data-option-index'));
    var value = btn.getAttribute('data-value');
    selectedOptions[optionIndex] = value;

    var container = btn.closest('.width-selector');
    if (container) {
      container.querySelectorAll('.js-option-selector').forEach(function(b) {
        b.classList.toggle('is-active', b.getAttribute('data-value') === value);
      });
    }

    updateVariantUI(getMatchingVariant());
  });
})();

/* ============================================================
   Product page — thumbnail gallery
   ============================================================ */
(function() {
  var thumbnails = qsa('.js-thumbnail');
  var mainImg = qs('#product-main-image');
  if (!thumbnails.length || !mainImg) return;

  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      mainImg.src = thumb.getAttribute('data-image-url');
    });
  });
})();

/* ============================================================
   Quantity selector
   ============================================================ */
(function() {
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-qty-minus')) {
      var input = e.target.closest('.qty-input').querySelector('.qty-input__val');
      if (input) input.value = Math.max(1, parseInt(input.value) - 1);
    }
    if (e.target.closest('.js-qty-plus')) {
      var input = e.target.closest('.qty-input').querySelector('.qty-input__val');
      if (input) input.value = parseInt(input.value) + 1;
    }
  });
})();

/* ============================================================
   Accordions
   ============================================================ */
(function() {
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.js-accordion');
    if (!trigger) return;
    var item = trigger.closest('.accordion-item');
    var content = item ? item.querySelector('.accordion-content') : null;
    if (!content) return;

    var isOpen = item.classList.contains('is-open');

    // Close all others in the same group
    var siblings = qsa('.accordion-item.is-open', item.parentElement);
    siblings.forEach(function(sib) {
      if (sib !== item) {
        sib.classList.remove('is-open');
        sib.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false');
        sib.querySelector('.accordion-content').style.maxHeight = '';
      }
    });

    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    content.style.maxHeight = isOpen ? '' : content.scrollHeight + 'px';
  });
})();

/* ============================================================
   Wishlist (localStorage)
   ============================================================ */
var Wishlist = {
  STORAGE_KEY: 'tt_wishlist',

  getIds: function() {
    try {
      return JSON.parse(localStorage.getItem(Wishlist.STORAGE_KEY) || '[]');
    } catch(e) { return []; }
  },

  setIds: function(ids) {
    try { localStorage.setItem(Wishlist.STORAGE_KEY, JSON.stringify(ids)); } catch(e) {}
  },

  toggle: function(productId) {
    var ids = Wishlist.getIds();
    var id = String(productId);
    var index = ids.indexOf(id);
    if (index === -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    Wishlist.setIds(ids);
    Wishlist.updateButtons(id, index === -1);
  },

  isWishlisted: function(productId) {
    return Wishlist.getIds().indexOf(String(productId)) !== -1;
  },

  updateButtons: function(productId, isWishlisted) {
    qsa('.js-wishlist-toggle[data-product-id="' + productId + '"]').forEach(function(btn) {
      btn.classList.toggle('is-wishlisted', isWishlisted);
      btn.setAttribute('aria-label', isWishlisted ? 'Remove from wishlist' : 'Save to wishlist');
    });
  },

  initPage: function() {
    var ids = Wishlist.getIds();
    ids.forEach(function(id) { Wishlist.updateButtons(id, true); });
  }
};

// Init wishlist state on page load
document.addEventListener('DOMContentLoaded', function() { Wishlist.initPage(); });

// Handle wishlist button clicks
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.js-wishlist-toggle');
  if (!btn) return;
  e.preventDefault();
  var productId = btn.getAttribute('data-product-id');
  if (productId) Wishlist.toggle(productId);
});

/* ============================================================
   Quick View Modal
   ============================================================ */
(function() {
  var modal = qs('#quick-view-modal');
  if (!modal) return;

  var overlay = modal.querySelector('.quick-view-modal__overlay');
  var closeBtn = modal.querySelector('.quick-view-modal__close');
  var body = modal.querySelector('#quick-view-body');

  function openModal() {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (overlay) overlay.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Quick view button click
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.js-quick-view');
    if (!btn) return;
    e.preventDefault();

    var handle = btn.getAttribute('data-product-handle');
    if (!handle || !body) return;

    body.innerHTML = '<div style="padding:40px;text-align:center;color:var(--color-muted);">Loading…</div>';
    openModal();

    fetch('/products/' + handle + '.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function(res) { return res.json(); })
    .then(function(product) {
      var variant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
      var img = product.featured_image || '';
      var price = variant ? (typeof formatMoney === 'function' ? formatMoney(variant.price) : '$' + (variant.price / 100).toFixed(2)) : '';

      body.innerHTML =
        '<div class="quick-view-modal__image">' +
          (img ? '<img src="' + img + '" alt="' + product.title + '" loading="lazy">' : '') +
        '</div>' +
        '<div style="padding:40px 0 40px 0;">' +
          '<div class="product-vendor-tag">Townties</div>' +
          '<h2 class="product-name" style="font-size:28px;">' + product.title + '</h2>' +
          '<div class="product-pricing" style="margin:16px 0;">' +
            '<span class="price-main">' + price + '</span>' +
          '</div>' +
          (product.description ? '<div class="quick-view-modal__description rte">' + product.description + '</div>' : '') +
          '<form action="/cart/add" method="post" id="quick-view-form">' +
            '<input type="hidden" name="id" value="' + (variant ? variant.id : '') + '">' +
            '<input type="hidden" name="quantity" value="1">' +
            '<div style="display:flex;gap:8px;margin-top:16px;">' +
              '<button type="submit" class="btn-atc" style="flex:1;">Add to Cart</button>' +
              '<a href="' + product.url + '" class="btn-outline-dark">View Full Details</a>' +
            '</div>' +
          '</form>' +
        '</div>';

      // Wire up ATC
      var qvForm = qs('#quick-view-form');
      if (qvForm) {
        qvForm.addEventListener('submit', function(e) {
          e.preventDefault();
          var vid = parseInt(qvForm.querySelector('[name="id"]').value);
          if (typeof Cart !== 'undefined') {
            Cart.add(vid, 1).then(function() {
              closeModal();
              // Open cart drawer
              var cartDrawer = qs('#cart-drawer');
              if (cartDrawer) {
                cartDrawer.classList.add('is-open');
                cartDrawer.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
                Cart.render();
                Cart.fetchUpsell();
              }
            });
          }
        });
      }
    })
    .catch(function() {
      body.innerHTML = '<div style="padding:40px;text-align:center;color:#c0392b;">Could not load product. <a href="/products/' + handle + '">View it here</a>.</div>';
    });
  });
})();

/* ============================================================
   Collection filter selects — redirect with tag
   ============================================================ */
(function() {
  document.addEventListener('change', function(e) {
    var sel = e.target.closest('.js-filter-select');
    var sort = e.target.closest('.js-sort-select');

    if (sel) {
      var val = sel.value;
      var path = window.location.pathname.split('/tagged/')[0];
      window.location.href = val ? path + '/tagged/' + val : path;
      return;
    }

    if (sort) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    }
  });
})();
